namespace advisorop.components.common {

    export class InvAccountListController {

        public accountStatus: number = 0; //0-active, 1-active and closed, 1-not finished
        public accounts: Array<domains.IAccount>;
        public dg: DevExpress.ui.dxDataGridOptions;
        public showClosedAccounts: boolean = false;
        mvDate: Date = null;
        public $router;

        static $inject = ["investorService", "$rootRouter"];
        constructor(
            private investorService: services.InvestorService,
            private $rootRouter: any
        ) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: false,
              
                noDataText: "Account Not Found",
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgAccountsXY"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "name", caption: "Account Title", width: 180, cellTemplate: "colFullName" },
                    { dataField: "number", caption: "Account Number", width: 100 },
                    { dataField: "usdMarketValue", caption: "Market Value", format: "currency", visible: (this.accountStatus == 0 || this.accountStatus == null) },
                    { dataField: "accountTypeDescription", caption: "Investment Type", width: 90 },
                    { dataField: "advisoryFirm.advisoryFirmName", caption: "Advisory Firm Name", width: 90 },
                    { dataField: "custodianName", caption: "Custodian Name", width: 90 },
                    //{ dataField: "titleTypeDescription", caption: "Type", width: 90 },
                    { dataField: "advisoryFirmMgtRoleDescripton", caption: "Firm Managed", width: 90 },
                    { dataField: "dateCreated", caption: "Created", dataType: "date", format: "shortDate", width: 90 },
                    { dataField: "statusDescription", caption: "Status", width: 100 },
                    //{ dataField: "manualAccount.manualAccountHoldingTypeDescription", caption: "Manual Account Type", width: 90 },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", cssClass: "tblOverflow", width: 140 }
                ],
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                     
                    if (e.row.rowType == "data") {
                        //console.log("Data: ", e.row.data, this.$rootRouter, this.$router);
                        let managed = e.row.data.advisoryFirmMgtRole == domains.AdvisoryFirmMgtRole.MANAGED;

                        // account-summary.html tab numbers are below for reference.
                        // it does not look like uib - tab supports index names as strings so we are using numbers.
                        //Tab 0: "General Information"
                        //Tab 2: "Outside Holdings"
                        //Tab 3: "Proposals"
                        //Tab 4: "Households and Groups"
                        //Tab 5: "Audit Account"
                        //Tab 6: "Edit Details"
                        //Tab 7: "Documentation"

                        //e.items.push({ text: "Account Summary", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 0) });
                        //e.items.push({ text: "Households and Groups", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 4) });
                        //e.items.push({ text: "Documentation", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 7) });

                        if (managed) {
                            // reports for managed accounts
                            //if (e.row.data.status >= domains.AccountStatus.OPENING) {
                            //    e.items.push({
                            //        text: "Reports", items: [
                            //            { text: "RTQ", onItemClick: () => window.open(`api/investor/getrtqxtrareport/${e.row.data.id}/0`,"_blank") },
                            //            { text: "Proposal", onItemClick: () => window.open(`api/investor/getproposalsimplereport/${e.row.data.id}/0`, "_blank") },
                            //            { text: "Pershing Agreement", onItemClick: () => window.open(`api/investor/getpershopformreportforaccount/${e.row.data.id}/0`, "_blank") },
                            //            { text: "Subscription Agreement", onItemClick: () => window.open(`api/investor/generatesubscriptionagreement/${e.row.data.id}/0`, "_blank") }
                            //        ]
                            //    })
                            //};
                        }
                    }
                },
                onCellPrepared: (e: any) => {
                    // DEMO - SIMULATION OF RIGHT MOUSE CLICK ...
                    //e.cellElement.find(".dx-datagrid-text-content").on("dxclick", function (event) {
                    //    var newEvent = $.extend({}, event, { type: "dxcontextmenu" });
                    //    event.stopPropagation();
                    //    $(this).trigger(newEvent);
                    //});
                },
                //selection: {
                //    mode: "single",
                //    showCheckBoxesMode: "onClick"
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onInvestorChanged({ id: data.id });
                //    }
                //}
            };
        }
        
        reloadAccounts() {
            //console.log(this.showClosedAccounts);
            this.loadAccounts();
        };


        loadAccounts() {

            this.mvDate = null;

            let rez: ng.IHttpPromise<domains.IAccount[]>
                = this.investorService.getAccounts(this.accountStatus, this.showClosedAccounts);

            rez.then(response => {
                //console.log(this.accounts);
                this.accounts = response.data;
                if (this.accounts.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    this.mvDate = this.accounts[0].marketValueDate;
                }
            }).catch((response) => {
                toastr.error("Accounts cannot be loaded. ERROR " + response.status + ":" + response.data);
            });
        };
        
        $onInit(): void {
            this.loadAccounts();
        }
        
    }
    
    class InvAccountList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                accountStatus: "<",
                $router: "<"
            };
            this.controller = InvAccountListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-account-list.html";
        }
    }
    angular.module(Constants.APP).component("invAccountList", new InvAccountList());

}